import { useState } from 'react';

import { DefaultAppPage } from 'layouts';
import { Button, Input } from 'ui';
import { StickyNav } from 'ui/StickyNav';

export const EditFullName = ({ initialValue, isSaving, onBack, postToApi }) => {
  const [newValue, setNewValue] = useState(initialValue);
  const isScreenValid = newValue.split(' ').length >= 2;

  const handleSubmitClick = (e) => {
    e.preventDefault();

    postToApi({ fullName: newValue });
  };

  return (
    <DefaultAppPage
      title="Full name"
      onBack={onBack}
      footerActions={
        <StickyNav>
          <Button
            expand
            onClick={handleSubmitClick}
            disabled={!isScreenValid || isSaving}
            isWorking={isSaving}
          >
            Update full name
          </Button>
        </StickyNav>
      }
    >
      <Input
        placeholder="Full name"
        autoFocus
        value={newValue}
        onChange={(e) => setNewValue(e.target.value)}
        data-testid="editFullName__input"
      />
    </DefaultAppPage>
  );
};
